import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBasket = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 576 512",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M576 216v16c0 13-11 24-24 24h-8l-26 183c-3 23-24 41-48 41H106c-24 0-45-18-48-41L32 256h-8c-13 0-24-11-24-24v-16c0-13 11-24 24-24h67L198 45a32 32 0 0152 38l-80 109h236L326 83a32 32 0 0152-38l107 147h67c13 0 24 11 24 24zM312 392V280a24 24 0 10-48 0v112a24 24 0 1048 0zm112 0V280a24 24 0 10-48 0v112a24 24 0 1048 0zm-224 0V280a24 24 0 10-48 0v112a24 24 0 1048 0z" })
});
export default SvgBasket;
